import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DataTable from 'base/components/table/DataTable/index';
import MainTitle from 'base/components/MainTitle/index';
import Header from 'base/components/Header/index';
import { AppsIcon, AddIcon } from 'base/components/Icon/index';
import { getAllSpaces } from 'spaces/store/selectors';
import { fetchAllSpaces, setActiveSpaceId } from 'spaces/store/actions';
import theme from 'theme/theme';
import Button from 'base/components/Button/index';
import ButtonGroup from 'base/components/ButtonGroup/index';
import { openModal } from 'modal/store/actions';
import { getEditColumn, getDeleteColumn } from 'base/components/table/RowActionButton';
import withGlobalFilter from 'base/components/table/withGlobalFilter';
import { LargeLabelCell, SmallLabelCell } from 'base/components/table';
import { getUsersById } from 'auth/store/users/selectors';

const FilteredTable = withGlobalFilter(DataTable);

class ManageSpaces extends React.Component {
  componentDidMount() {
    const { fetchAll } = this.props;
    fetchAll();
  }

  handleEdit = (data) => {
    const { setActiveSpaceId, openModal } = this.props;
    setActiveSpaceId(data.id);
    openModal('SPACE_EDIT');
  };

  handleDelete = (data) => {
    const { setActiveSpaceId, openModal } = this.props;
    setActiveSpaceId(data.id);
    openModal('SPACE_DELETE');
  };

  render() {
    const { spaces, openModal, usersById } = this.props;

    const columns = [
      {
        Header: 'Name',
        accessor: 'name',
        Cell: LargeLabelCell('name'),
        showOnMobile: true,
      },
      {
        id: 'owner',
        Header: 'Space owner',
        accessor: (row) => usersById[row.owner] && usersById[row.owner].fullName,
        Cell: SmallLabelCell('owner'),
        showOnMobile: true,
        width: 180,
      },
      getEditColumn(this.handleEdit),
      getDeleteColumn(this.handleDelete),
    ];

    return (
      <>
        <Header>
          <MainTitle>
            <AppsIcon />
            {' '}
Manage Spaces
          </MainTitle>
          <ButtonGroup pullRight>
            <Button onClick={() => openModal('SPACE_CREATE')}>
              <AddIcon color={theme.colors.medium} />
              {' '}
New space
            </Button>
          </ButtonGroup>
        </Header>
        <FilteredTable
          data={spaces}
          columns={columns}
          defaultSorted={[{
            id: 'name',
            desc: false,
          }]}
          filterKeys={['name']}
          filterLabel="Filter by name..."
        />
      </>
    );
  }
}
ManageSpaces.propTypes = {
  spaces: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchAll: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  setActiveSpaceId: PropTypes.func.isRequired,
  usersById: PropTypes.objectOf(PropTypes.any).isRequired,
};


const mapStateToProps = (state) => ({
  spaces: getAllSpaces(state),
  usersById: getUsersById(state),
});

const mapDispatchToProps = {
  fetchAll: fetchAllSpaces,
  openModal,
  setActiveSpaceId,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageSpaces);
